import React, { useState } from 'react';
import { Grid, Column } from 'components';
import ProductBlock from 'components/RelatedProducts/ProductBlock';
import {
  ProductTabsWrapper,
  ProductTabList,
  MobileProductTabList,
  ProductTab,
  ProductTabPanel,
  MobileProductTabListWrapper
} from './styled';
import { useWindowSize, DEVICE_SIZE_SMALL } from 'hooks/useWindowSize';
import { trackAssetClicked } from 'analytics/itly/hooks';

interface ProductTabObj {
  label: string;
  link?: string;
  products: Array<{
    image: string;
    name: string;
    price: string;
    url: string;
  }>;
}
interface ProductTabsProps {
  products: Array<ProductTabObj>;
}

const ProductTabs = ({ products }: ProductTabsProps): React.JSX.Element => {
  const [isMobileTabListFocused, setIsMobileTabListFocused] = useState(false);
  const { deviceSize } = useWindowSize();

  return (
    <ProductTabsWrapper selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
      {deviceSize === DEVICE_SIZE_SMALL ? (
        <MobileProductTabListWrapper
          isFocused={isMobileTabListFocused}
          onClick={() => setIsMobileTabListFocused(!isMobileTabListFocused)}
        >
          <MobileProductTabList>
            {products.map(cat => (
              <ProductTab key={cat.label}>{cat.label}</ProductTab>
            ))}
          </MobileProductTabList>
        </MobileProductTabListWrapper>
      ) : (
        <ProductTabList>
          {products.map(cat => (
            <ProductTab key={cat.label}>{cat.label}</ProductTab>
          ))}
        </ProductTabList>
      )}

      {products.map(cat => (
        <ProductTabPanel key={cat.label}>
          <>
              <Grid
                gutter={25}
                css={`
                  margin: 0 -16px;
                `}
              >
                {cat.products.map(product => (
                  <Column key={product.name} size={6} medium={cat.products.length === 4 ? 3 : 4}>
                    <ProductBlock
                      name={product.name}
                      alt={product.name}
                      img={product.image}
                      href={product.url || '#'}
                      details={product.price}
                    />
                  </Column>
                ))}
              </Grid>
              {cat.link ? (
                <a
                  onClick={() => trackAssetClicked(cat.label, 'ProductTabsPanel', cat.link)}
                  href={cat.link}
                >
                  View all {cat.label}
                </a>
              ) : null}
            </>
        </ProductTabPanel>
      ))}
    </ProductTabsWrapper>
  );
};
export default ProductTabs;
